module.exports = __webpack_public_path__ + "img/Invasion-BRCA_10X_Section2.e95d9942.png";